"use client";

import Image from "next/image";
import { CheckCircle2, Crown, Sparkles, Users, Download, Palette } from "lucide-react";
import { useRouter } from "next/navigation";

import { useSubscriptionModal } from "@/features/subscriptions/store/use-subscription-modal";

import {
  Dialog,
  DialogTitle,
  DialogFooter,
  DialogHeader,
  DialogContent,
  DialogDescription,
} from "@/components/ui/dialog";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";

export const SubscriptionModal = () => {
  const router = useRouter();
  const { isOpen, onClose } = useSubscriptionModal();

  const handleUpgrade = () => {
    console.log("Upgrade to Pro button clicked");
    onClose();
    router.push("/subscription");
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader className="flex items-center space-y-4">
          <Image
            src="/favicon.svg"
            alt="Logo"
            width={36}
            height={36}
          />
          <DialogTitle className="text-center flex items-center justify-center gap-2">
            <Crown className="size-6 text-yellow-500" />
            프로로 업그레이드
          </DialogTitle>
          <DialogDescription className="text-center">
            모든 프리미엄 기능과 AI 기반 도구를 사용해보세요
          </DialogDescription>
        </DialogHeader>
        <Separator />
        <ul className="space-y-3">
          <li className="flex items-center">
            <Download className="size-5 mr-3 text-blue-500" />
            <div>
              <p className="text-sm font-medium">모든 내보내기 형식</p>
              <p className="text-xs text-muted-foreground">PDF, SVG, WebP 등</p>
            </div>
          </li>
          <li className="flex items-center">
            <Users className="size-5 mr-3 text-green-500" />
            <div>
              <p className="text-sm font-medium">실시간 협업</p>
              <p className="text-xs text-muted-foreground">공유, 댓글 및 공동 편집</p>
            </div>
          </li>
          <li className="flex items-center">
            <Sparkles className="size-5 mr-3 text-purple-500" />
            <div>
              <p className="text-sm font-medium">AI 배경 제거</p>
              <p className="text-xs text-muted-foreground">즉시 배경 제거</p>
            </div>
          </li>
          <li className="flex items-center">
            <Palette className="size-5 mr-3 text-pink-500" />
            <div>
              <p className="text-sm font-medium">AI 이미지 생성</p>
              <p className="text-xs text-muted-foreground">AI 프롬프트로 이미지 생성</p>
            </div>
          </li>
          <li className="flex items-center">
            <CheckCircle2 className="size-5 mr-3 text-orange-500" />
            <div>
              <p className="text-sm font-medium">프리미엄 템플릿</p>
              <p className="text-xs text-muted-foreground">독점 디자인 이용</p>
            </div>
          </li>
        </ul>
        <DialogFooter className="pt-4 mt-4 gap-y-2">
          <Button
            className="w-full"
            onClick={handleUpgrade}
          >
            <Crown className="size-4 mr-2" />
            프로로 업그레이드
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
